/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dr_Room_Card_Hidden_HintInputs */

const en_dr_room_card_hidden_hint = /** @type {(inputs: Dr_Room_Card_Hidden_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`written, not yet revealed`)
};

const id_dr_room_card_hidden_hint = /** @type {(inputs: Dr_Room_Card_Hidden_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sudah ditulis, belum dibuka`)
};

/**
* | output |
* | --- |
* | "written, not yet revealed" |
*
* @param {Dr_Room_Card_Hidden_HintInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const dr_room_card_hidden_hint = /** @type {((inputs?: Dr_Room_Card_Hidden_HintInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dr_Room_Card_Hidden_HintInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_dr_room_card_hidden_hint(inputs)
	return en_dr_room_card_hidden_hint(inputs)
});